export const FETCH_USER = 'FETCH_USER';
export const FETCH_SURVEYS = 'FETCH_SURVEYS';
export const DELETE_SURVEY = 'DELETE_SURVEY';